import _extends from '../../../../node_modules/.pnpm/@babel_runtime@7.24.0/node_modules/@babel/runtime/helpers/esm/extends.js';
import { __rest } from '../../../../node_modules/.pnpm/node_modules/tslib/tslib.es6.js';
import React, { useState } from 'react';
import { DatePicker } from 'antd-mobile';
import { RightOutline } from 'antd-mobile-icons';
import './index.less.js';
import { isDate, isFunction, isString } from 'lodash';
import dayjs from 'dayjs';
import useLanguage from '../../../../hooks/useLangugle/index.js';
import classNames from 'classnames';

var DatePickerWrap = function DatePickerWrap(props) {
  var _a;
  var locale = useLanguage('Common');
  var _b = props.placeholder,
    placeholder = _b === void 0 ? locale['pleaseSelect'] : _b,
    value = props.value,
    onChange = props.onChange,
    _c = props.format,
    format = _c === void 0 ? 'YYYY-MM-DD' : _c,
    restProps = __rest(props, ["placeholder", "value", "onChange", "format"]);
  var disabled = restProps.disabled;
  var _d = useState(false),
    visible = _d[0],
    setVisible = _d[1];
  var onOpen = function onOpen() {
    if (disabled) {
      return;
    }
    setVisible(true);
  };
  var onClose = function onClose() {
    setVisible(false);
  };
  var onConfirm = function onConfirm(_value) {
    if (isFunction(onChange)) {
      onChange(_value);
    }
  };
  var handleFormat = function handleFormat(date) {
    if (isFunction(format)) {
      return format(date);
    }
    if (isString(format)) {
      return dayjs(date).format(format);
    }
    return '-';
  };
  var pickerDateCls = classNames((_a = {}, _a['ti-form-date-picker'] = true, _a['ti-form-date-picker-disabled'] = disabled, _a));
  var pickerDateStyle = {
    '--ti-placeholder-color': '#9EA1A7'
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: pickerDateStyle,
    className: pickerDateCls,
    onClick: onOpen
  }, isDate(value) ? /*#__PURE__*/React.createElement("div", {
    className: "ti-form-date-picker-content"
  }, handleFormat(value)) : /*#__PURE__*/React.createElement("div", {
    className: "ti-form-date-picker-placeholder"
  }, placeholder), /*#__PURE__*/React.createElement("div", {
    className: "ti-form-date-picker-icon"
  }, /*#__PURE__*/React.createElement(RightOutline, {
    color: "#9EA1A7"
  }))), /*#__PURE__*/React.createElement(DatePicker, _extends({}, restProps, {
    visible: visible,
    onClose: onClose,
    onConfirm: onConfirm
  })));
};

export { DatePickerWrap as default };
